export class ResultVO{
    result:string;
    reason:string;
    errorCode: string;
    description?: string;
    exception?: string;
    exceptionStack?: string;
    parameters?: string;
}